<div class="content" *ngIf="!isLoadingResults">
  <title-line title="Certificados"></title-line>
  <form [formGroup]="form" class="flex flex-form">
    <div class="flex form-column">
      <div class="flex form-registro-center">
        <mat-form-field>
          <mat-label>Status do certificado.:</mat-label>
          <mat-select formControlName="statusCertificado">
            <mat-option [value]="1">AGUARDANDO EMISSÃO</mat-option>
            <mat-option [value]="2">DISPONÍVEL PARA RETIRADA</mat-option>
            <mat-option [value]="3" [disabled]="certificado?.statusCertificado < 2" >ENTREGUE AO ALUNO</mat-option>
          </mat-select>
          <mat-error>Informação necessária</mat-error>
        </mat-form-field>
      </div>
      <div class="flex form-registro-center" *ngIf="statusCertificado >= 2">
        <mat-form-field>
          <mat-label>Data do recebimento no suporte.:</mat-label>
          <input matInput formControlName="dataRecebimentoSuporte" [matDatepicker]="dataRecebimentoSuporte">
          <mat-datepicker-toggle matSuffix [for]="dataRecebimentoSuporte"></mat-datepicker-toggle>
          <mat-datepicker #dataRecebimentoSuporte></mat-datepicker>
          <mat-error>Informação necessária</mat-error>
        </mat-form-field>
      </div>
      <div class="flex form-registro-center" *ngIf="statusCertificado >= 2">
        <mat-form-field>
          <mat-label>GDAE/SED/D.O.E.:</mat-label>
          <input appTitlecase formControlName="gdae" matInput>
          <mat-error>Informação necessária</mat-error>
        </mat-form-field>
      </div>
      <div class="flex form-registro-center" *ngIf="statusCertificado === 3">
        <mat-form-field>
          <mat-label>Data de entrega ao aluno.:</mat-label>
          <input matInput formControlName="dataEntregaAluno" [matDatepicker]="dataEntregaAluno">
          <mat-datepicker-toggle matSuffix [for]="dataEntregaAluno"></mat-datepicker-toggle>
          <mat-datepicker #dataEntregaAluno></mat-datepicker>
          <mat-error>Informação necessária</mat-error>
        </mat-form-field>
      </div>
      <div class="flex form-registro-center" *ngIf="statusCertificado === 3" style="margin-left:24px;">
        <mat-label style="text;">Recibo de Retirada</mat-label>
      </div>
      <div class="flex form-registro-center" *ngIf="statusCertificado === 3" style="margin-left:24px;">
        <!-- <label> Recibo de Retirada</label> -->
        <button *ngIf="certificado?.anexoId === 0" type="button" class="yellow" mat-icon-button
          matTooltip="Necessita anexo">
          <mat-icon>report_problem</mat-icon>
        </button>
        <button type="button" (click)="download(certificado?.anexoId)" [disabled]="certificado?.anexoId === 0"
          color="primary" mat-icon-button matTooltip="Download">
          <mat-icon>arrow_downward</mat-icon>
        </button>
        <button (click)="fileUp.click(); anexoId" color="primary" mat-icon-button
          matTooltip="Upload">
          <mat-icon>arrow_upward</mat-icon>
        </button>
      </div>
      <div class="flex form-registro-center">
        <div class="flex align-center" *ngIf="!desabilitarForm">
          <button mat-raised-button color="primary" type="button" (click)="salvarData(false)"
            [disabled]="desabilitarForm">Salvar</button>
        </div>
      </div>
    </div>
  </form>
</div>
<input #fileUp class="file-upload" type="file" (change)="loadFile($event)">
<div *ngIf="certificadosEmitidos">
  <title-line title="Certificados Emitidos"></title-line>
  <div class="table">
    <table mat-table [dataSource]="certificadosEmitidos">
      <ng-container matColumnDef="tabDataSolicitacao">
        <th mat-header-cell *matHeaderCellDef> Data da Solicitação </th>
        <td mat-cell *matCellDef="let element">
          {{element.dataRecebimentoSuporte | date: 'dd/MM/yyyy'}}
        </td>
      </ng-container>

      <ng-container matColumnDef="tabgdae">
        <th mat-header-cell *matHeaderCellDef> GDAE.: </th>
        <td mat-cell *matCellDef="let element"> {{ element.gdae }} </td>
      </ng-container>

      <ng-container matColumnDef="tabDataEmissao">
        <th mat-header-cell *matHeaderCellDef> Data Entrega Aluno </th>
        <td mat-cell *matCellDef="let element"> {{ element.dataEntregaAluno }} </td>
      </ng-container>

      <ng-container matColumnDef="tabDownload">
        <th mat-header-cell *matHeaderCellDef> Download </th>
        <td mat-cell *matCellDef="let element"> {{ element.statusProva }} </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
